import { useState, useEffect } from 'react';
import { Modal } from 'src/components/baseComponents';
import { CommonFormProps } from '.';
import { analytics } from 'src/services';
import { getAppointmentDetailsForAnalytics } from 'src/utils';
import * as Yup from 'yup';

type Props = CommonFormProps;

export const ReviewOfSystems = ({
  form,
  isOpen,
  onSave,
  appointment,
  loading,
}: Props) => {
  const [initialValues, setInitialValues] = useState({});
  const [fields, setFields] = useState<any[]>([]);
  const [validationSchema, setValidationSchema] = useState<
    Yup.ObjectSchema<any>
  >(Yup.object().shape({}));

  const reviewSystemValue = form?.content as any[];

  useEffect(() => {
    const updatedValidationSchema = reviewSystemValue?.reduce(
      (schema, item) => {
        if (item.optional === 'false') {
          const key = item.item.toLowerCase().replace(/\s+/g, '_');
          const validationRule =
            item.type === 'checkbox'
              ? Yup.bool().oneOf([true], `${item.item} must be checked`)
              : Yup.string().required(`${item.item} is required`);

          return schema.shape({
            [key]: validationRule,
          });
        }

        return schema;
      },
      Yup.object()
    );
    setValidationSchema(updatedValidationSchema);
  }, []);

  useEffect(() => {
    const updatedValuesArray = reviewSystemValue.map((curr) => {
      const key = curr.item.toLowerCase().replace(/\s+/g, '_');
      return { [key]: '' };
    });

    const updatedValues = Object.assign({}, ...updatedValuesArray);
    setInitialValues((prevValues) => ({ ...prevValues, ...updatedValues }));
  }, []);

  useEffect(() => {
    const transformedArray = reviewSystemValue.map((item) => {
      if (item.type !== 'header' && item.type !== 'label') {
        const transformedItem = {
          name: item.item.toLowerCase().replace(/\s+/g, '_'),
          type: item.type,
          title: item.item,
          placeholder: item.placeholder ? item.placeholder : '',
          autoComplete: 'off',
        };
        Object.assign(transformedItem, { options: item.options });
        return transformedItem;
      }
      return {
        name: item.item,
        type: item.type,
        title: item.item,
      };
    });
    setFields(transformedArray);
  }, []);

  const handleSubmit = async (values: any) => {
    analytics.track(
      'Clicked Submit In ROS Form',
      getAppointmentDetailsForAnalytics(appointment!)
    );
    if (!values) {
      return;
    }
    const filteredValues = filterValues(values);
    const payload = {
      response: filteredValues,
      form_type: 'Review_of_Systems',
    };
    await onSave(payload);
  };

  const filterValues = (values: any) => {
    const filtered: any = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== false && value !== '') {
        filtered[key] = value;
      }
    }
    return filtered;
  };

  return (
    <div>
      {/* @ts-ignore */}
      <Modal
        open={isOpen}
        className={'review-of-system-modal'}
        formClassName={'grid grid-cols-2 gap-4'}
        initialValues={initialValues}
        validationSchema={validationSchema}
        submitButtonText="Submit"
        cancelButtonText=""
        closable={false}
        centered={true}
        fields={fields}
        handleSubmit={handleSubmit}
        onSubmitLoading={loading}
        disableSubmit={loading}
      />
    </div>
  );
};
